import { InjectionToken } from '@angular/core';
import { VoucherRepository } from '../domain/repository/voucher.repository';

export const VOUCHER_REPOSITORY = new InjectionToken<VoucherRepository>('VOUCHER_REPOSITORY');
